import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  onChange: (_: Date) => void;
  value?: Date;
  rounded?: boolean;
  includeHours?: boolean;
  timeZone?: string;
}

export default function AvenueDatePicker({ onChange, value, rounded = true, includeHours = true, timeZone }: Props) {
  // This is not ideal, but the DatePicker component does not have timeZones built in natively.
  // Building our custom time zone adjustment as a wrapper to the DatePicker, as suggested here:
  // https://github.com/Hacker0x01/react-datepicker/issues/1787

  // This gets the offset between browser and set timezone in milliseconds.
  // Offset is 0 if no timezone is set
  const now = new Date();
  const browserOffset = now.getTimezoneOffset();
  const clientTimeZoneOffset = timeZone ? moment.tz(timeZone).utcOffset() : -1 * browserOffset;
  const totalOffset = (browserOffset + clientTimeZoneOffset) * 60 * 1000;

  // This changes the date to whatever the user set in their timezone (as opposed to the timezone of their browser)
  const onChangeWithTimeZoneAdjustment = (date: Date) => {
    const modifiedDate = new Date(date.getTime() - totalOffset);
    onChange(modifiedDate);
  };

  const selectedValueWithTimeZoneAdjustment = !value ? undefined : !timeZone ? value : new Date(value.getTime() + totalOffset);

  return (
    <DatePicker
      className={`bg-white-100 min-h-[42px] text-center cursor-pointer text-gray-400 text-sm border border-gray-300 py-1.5 ${rounded ? "rounded-full" : ""}`}
      onChange={onChangeWithTimeZoneAdjustment}
      selected={selectedValueWithTimeZoneAdjustment}
      showTimeInput
      dateFormat={`MM/dd/yyyy ${includeHours ? "hh:mm aa" : ""} `}
    />
  );
}
